import React from 'react';
import { RefreshCw } from 'lucide-react';

/**
 * BusyIcon — the ONE "this button is working" sign (Apal 2026-11-03: "anything
 * that's loading must give loading effect … similarity of loading anything
 * through processing and/or backend call").
 *
 * A button that starts work (Save, Download, Export, Test now, Dismiss,
 * Activate…) swaps its own icon for the same turning arrows the page strip
 * uses, is disabled, and names the work in its label ("Saving…"). The data
 * that changes shows its own loading effect (strip + skeleton or dim).
 * docs/UI_GUIDELINES.md §5c.
 */
const BusyIcon = ({ busy, icon: Icon, className = 'w-4 h-4' }) => (busy
  ? <RefreshCw className={`${className} animate-spin`} aria-hidden data-busy="" />
  : (Icon ? <Icon className={className} aria-hidden /> : null));

export default BusyIcon;
